import {
  StoreMallDirectoryOutlined,
  RestaurantMenuOutlined,
  ListAltOutlined,
  ChatOutlined,
  ScheduleOutlined,
  PeopleAltOutlined,
  PaymentsOutlined,
  CachedOutlined,
  EventSeatOutlined,
} from "@mui/icons-material";
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
// import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
export const settingsInfo = [
  {
    icon: <StoreMallDirectoryOutlined />,
    heading: "Business Info",
    description: "Manage your business information, & branches",
    route: "business-info",
  },
  {
    icon: <RestaurantMenuOutlined />,
    heading: "Product Settings",
    description: "Manage discounts, tax type, taxes, and delivery charges",
    route: "product-settings",
  },
  {
    icon: <ListAltOutlined />,
    heading: "Order Settings",
    description: "Manage your orders, pickup, & delivery options",
    route: "order-settings",
  },
  {
    icon: <ChatOutlined />,
    heading: "Communication Settings",
    description: "Manage your email & SMS settings",
    route: "communication-settings",
  },
  {
    icon: <ScheduleOutlined />,
    heading: "Business Hours",
    description: "Manage your branch wise business hours",
    route: "business-hours",
  },
  {
    icon: <EventSeatOutlined />,
    heading: "Reservation",
    description: "Manage your reservation hours & details",
    route: "reservation",
  },
  {
    icon: <PeopleAltOutlined />,
    heading: "Users",
    description: "Manage users & generate POS key",
    route: "users",
  },
  // TODO: need this  later
  // {
  //   icon: <PaymentsOutlined />,
  //   heading: "Integration",
  //   description: "Integrate payments to your online store to receive payments",
  //   route: "integration",
  // },
 {
    icon: <WorkHistoryIcon />,
    heading: "Activity Logs",
    description: "User Activity Logs",
    route: "activity-logs",
  },
  {
    icon: <ShoppingCartCheckoutIcon />,
    heading: "Checkout Settings (New)",
    description: "Delivery Charges Settings for New Checkout",
    route: "delivery-charges",
  },
  {
    icon: <CachedOutlined />,
    heading: "Cache Settings",
    description: "Cache",
    route: "",
  },
];

export const integrationInfo = [
  {
    icon: "https://images-beta.tossdown.com/images/c4d3ef7e-918b-4257-a232-ab1d7fef080b.webp",
    heading: "Stripe",
    description:
      "Integrate stripe payments to your online store to receive payments.",
    route: "payments",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/af034f99-acf9-42a1-abb1-c14ac4fc4b75.webp",
    heading: "Firebase",
    description: "Integrate firebase to your online store.",
    route: "firebase",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/cdc8751e-3cb9-4099-9815-b33472458b95.webp",
    heading: "Google analytics",
    description: "Integrate google analytics to your online store.",
    route: "google-analytics",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/68d9c8c1-be4e-49ed-9166-3f425d659610.webp",
    heading: "Canada Post",
    description: "Integrate Canada Post to your online store.",
    route: "canadaPost",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/70b0bec4-fbb7-4d1c-9cf6-9e8b4fd0d825.webp",
    heading: "TCS Express",
    description: "Integrate TCS Express to your online store.",
    route: "TCSExpress",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/c1cd6cf5-b1f5-4ac0-befc-e6feadd50f07.webp",
    heading: "eShipper",
    description: "Integrate eShipper to your online store.",
    route: "eShipper",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/2f13eb93-a395-44ba-b5cf-24124f94a303.webp",
    heading: "ShipStation",
    description: "Integrate ShipStation to your online store.",
    route: "ShipStation",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/ef3f53ad-80d8-405c-b535-e6f1caabce62.webp",
    heading: "Pandago",
    description: "Integrate Pandago to your online store.",
    route: "Pandago",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/58573469-e982-4ba1-a206-cc9d0be02559.webp",
    heading: "DoorDash",
    description: "Integrate DoorDash to your online store.",
    route: "DoorDash",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/e8234c41-1ea0-49d6-a398-6a0749ab485b.webp",
    heading: "Bykea",
    description: "Integrate Bykea to your online store.",
    route: "Bykea",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/292b4540-bab6-475d-beed-d85202e12995.webp",
    heading: "Twilio",
    description: "Integrate Twilio to your online store.",
    route: "Twillio",
    connected: false,
  },
  {
    icon: "https://images-beta.tossdown.com/images/68553f4a-b8b0-4123-bd21-1844fde6dcbd.webp",
    heading: "SMS",
    description: "Integrate SMS to your online store.",
    route: "Sms",
    connected: false,
  },
];

export const orderSettings = [
  {
    heading: "Delivery Options",
    description:
      "Manage your business's delivery options i.e delivery, pickup, & reservations",
    route: "delivery-options",
  },
  {
    heading: "Order Options",
    description: "Manage your business's order options",
    route: "order-options",
  },
  {
    heading: "Delivery Areas",
    description: "Manage your business's delivery areas",
    route: "delivery-areas",
  },
  {
    heading: "Delivery Ranges",
    description: "Manage your business's delivery ranges",
    route: "delivery-ranges",
  },
  {
    heading: "Payment Types",
    description: "Manage your POS payment methods",
    route: "payment-types",
  },
  // {
  //   heading: "Delivery Charges",
  //   description: "Manage your delivery charges",
  //   route: "delivery-charges",
  // },
];

export const businessInfoSettings = [
  {
    heading: "Profile",
    description:
      "Manage your business name, logo, timezone, about business, & currency",
    route: "profile",
  },
  {
    heading: "Locations",
    description: "Manage your business's locations, add, edit, or delete",
    route: "locations",
  },
];

export const communicationSettings = [
  {
    heading: "Orders",
    description: "Manage your email settings for Orders",
    route: "orders",
  },
  {
    heading: "Reservations",
    description: "Manage your sms settings for Reservations",
    route: "reservations",
  },
];

export const ordersCommunicationSettings = [
  {
    heading: "Email",
    description: "Manage your email settings",
    route: "email",
  },
  {
    heading: "SMS",
    description: "Manage your sms settings",
    route: "sms",
  },
];

export const reservationSettings = [
  {
    heading: "Hours",
    description: "Manage your reservation availability hours",
    route: "hours",
  },
  {
    heading: "Details",
    description: "Manage your reservation details",
    route: "details",
  },
];

export const pageSEOKeywords = [
  { heading: "Business Name", keyword: "<name>" },
  { heading: "Category Name / Title Menu Page", keyword: "<category_name>" },
  { heading: "Product Name", keyword: "<product_name>" },
  { heading: "Product Description", keyword: "<product_desc>" },
  { heading: "Business Username", keyword: "<username>" },
  { heading: "Business Locality", keyword: "<locality>" },
  { heading: "Business Country", keyword: "<country>" },
  { heading: "Business Area", keyword: "<area>" },
];
